module.exports = __webpack_public_path__ + "static/media/strapping_dispenser.a16d837d.png";